// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  HOME_SET_SELECTED_SCHEDULE,
} from './constants';

export function setSelectedSchedule(key, scheduleId) {
  return {
    type: HOME_SET_SELECTED_SCHEDULE,
    data: {key, scheduleId}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SET_SELECTED_SCHEDULE:
      return {
        ...state,
        selectedSchedules: 
        {
          ...state.selectedSchedules,
          [action.data.key] : action.data.scheduleId
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setSelectedSchedule.js